/**
 * Generated by @openapi-codegen
 *
 * @version 1.0.0
 */
import * as reactQuery from 'app/src/shared/helpers/reactquery'
import { CatalogsummaryContext, useCatalogsummaryContext } from './catalogsummary-context'
import type * as Fetcher from './catalogsummary-fetcher'
import { catalogsummaryFetch } from './catalogsummary-fetcher'
import type * as Schemas from './catalogsummary-schemas'

export type CatalogSummaryListPathParams = {
  templateBasePath?: string
}

export type CatalogSummaryListError = Fetcher.ErrorWrapper<{
  status: 400
  payload: {
    /**
     * Error type
     */
    type: string
    /**
     * HTTP status
     */
    status: number
    /**
     * Error message
     */
    title: string
    /**
     * Unique return code
     *
     * @format int32
     */
    rc?: number
  }
}>

export type CatalogSummaryListVariables = {
  pathParams?: CatalogSummaryListPathParams
} & CatalogsummaryContext['fetcherOptions']

/**
 * Returns the Catalog Summary
 */
export const fetchCatalogSummaryList = (variables: CatalogSummaryListVariables, signal?: AbortSignal) =>
  catalogsummaryFetch<Schemas.CatalogSummary, CatalogSummaryListError, undefined, {}, {}, CatalogSummaryListPathParams>({
    url: '/{templateBasePath}/catalogSummary',
    method: 'get',
    ...variables,
    signal,
  })

/**
 * Returns the Catalog Summary
 */
export const useCatalogSummaryList = <TData = Schemas.CatalogSummary>(
  variables: CatalogSummaryListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.CatalogSummary, CatalogSummaryListError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCatalogsummaryContext(options)
  return reactQuery.useQuery<Schemas.CatalogSummary, CatalogSummaryListError, TData>({
    queryKey: queryKeyFn({
      path: '/{templateBasePath}/catalogSummary',
      operationId: 'catalogSummaryList',
      variables,
    }),
    queryFn: ({ signal }) => fetchCatalogSummaryList({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type QueryOperation = {
  path: '/{templateBasePath}/catalogSummary'
  operationId: 'catalogSummaryList'
  variables: CatalogSummaryListVariables
}
